export default [
    {
        path: '/evaluation/review-draft-contract/:id',
        name: 'review-draft-contract',
        meta: {
            title: "Review Draft Contract",
            authRequired: true,
            privileges: [],
        },
        component: () => import("../views/contract-management/reviewDraftContract.vue"),
    },
    {
        path: "/contract-management/review-awarded-contracts",
        name: "review-awarded-contracts",
        meta: {
            title: "Review Awarded Contracts",
            authRequired: true,
            /*  privileges: [
                  'ROLE_PRIVILEGE_HERE',
              ]*/
        },
        component: () => import("../views/contract-management/review-awarded-contracts.vue"),
    },
    {
        path: "/contract-management/contract-review",
        name: "contract-review",
        meta: {
            title: "list contracts workspace",
            authRequired: true,
            /*  privileges: [
                   'ROLE_PRIVILEGE_HERE',
               ]*/
        },
        component: () => import("../views/contract-management/contract-review.vue"),
    },
    {
        path: '/contract-management/projects-list',
        name: 'Projects-List',
        meta: {
            title: "Projects",
            //authRequired: true,
            /*privileges: [
                'VIEW_KNOWLEDGE_BASE',
            ]*/
        },
        component: () => import("../views/contract-management/projects-list.vue"),
    },
    {
        path: "/contract-management/view-contract-workspace",
        name: "view-contract-workspace",
        meta: {title: "View Workspace", authRequired: false},
        component: () => import("../views/contract-management/view-workspace.vue"),
    },

    {
        path: "/contract-management/contract-termination-requests",
        name: "Termination-Requests",
        meta: {title: "Contract Termination Requests", authRequired: false},
        component: () => import("../views/contract-management/contract-termination-request.vue"),
    },

    {
        path: "/contract-management/terminated-contract",
        name: "Terminated-Contracts",
        meta: {title: "Terminated Contracts", authRequired: false},
        component: () => import("../views/contract-management/terminated-contracts.vue"),
    },
]